import { i18next as M, genUIDefinitionStore as pe, defineGenUIComponent as de, MessageTypeRegistry as he, ChativaElement as b, t as ue, chatStore as fe, GenUIHtmlElement as oe } from "@chativa/core";
import { GENUI_COMPONENT_EVENT as rt, GenUIElement as it, GenUIHtmlElement as st, defineGenUIComponent as ot, genUIDefinitionStore as nt, renderTemplate as at, sanitizeHtml as lt } from "@chativa/core";
import { css as g, html as n, nothing as c, svg as L } from "lit";
import { property as l, customElement as m, state as $ } from "lit/decorators.js";
const ge = {
  "genui.form.processing": "Processing…",
  "genui.form.submit": "Submit",
  "genui.form.successTitle": "Success",
  "genui.form.successDefault": "Done!",
  "genui.form.errorDefault": "Something went wrong.",
  "genui.appointment.title": "Book an Appointment",
  "genui.appointment.submit": "Book Now",
  "genui.appointment.successDefault": "Appointment successfully booked.",
  "genui.appointment.codeHint": "Please save this code for your reference.",
  "genui.appointment.copy": "Copy",
  "genui.appointment.copied": "Copied!",
  "genui.rating.ariaLabel": "Star rating",
  "genui.rating.starLabel": "{{count}} star",
  "genui.rating.submit": "Submit",
  "genui.rating.thankYou": "Thank you for your feedback!",
  "genui.datePicker.label": "Select date"
}, be = {
  "genui.form.processing": "İşleniyor…",
  "genui.form.submit": "Gönder",
  "genui.form.successTitle": "Başarılı",
  "genui.form.successDefault": "Tamamlandı!",
  "genui.form.errorDefault": "Bir şeyler ters gitti.",
  "genui.appointment.title": "Randevu Al",
  "genui.appointment.submit": "Şimdi Randevu Al",
  "genui.appointment.successDefault": "Randevunuz başarıyla alındı.",
  "genui.appointment.codeHint": "Bu kodu referans olarak saklayın.",
  "genui.appointment.copy": "Kopyala",
  "genui.appointment.copied": "Kopyalandı!",
  "genui.rating.ariaLabel": "Yıldız puanı",
  "genui.rating.starLabel": "{{count}} yıldız",
  "genui.rating.submit": "Gönder",
  "genui.rating.thankYou": "Geri bildiriminiz için teşekkür ederiz!",
  "genui.datePicker.label": "Tarih seçin"
};
function ie() {
  M.addResources("en", "translation", ge), M.addResources("tr", "translation", be);
}
M.isInitialized ? ie() : M.on("initialized", ie);
const U = /* @__PURE__ */ new Map(), d = {
  /**
   * Register a LitElement constructor under a name.
   * @param name      Must match `AIChunkUI.component` sent by the connector.
   * @param component LitElement constructor (or any HTMLElement subclass).
   * @param opts.schema  Optional schema for prop validation at render time.
   */
  register(e, t, s) {
    U.set(e, { component: t, schema: s?.schema });
  },
  /** Resolve a registered entry, or undefined if not found. */
  resolve(e) {
    return U.get(e);
  },
  has(e) {
    return U.has(e);
  },
  /** Remove a registration. */
  unregister(e) {
    U.delete(e);
  },
  /** List all registered names. */
  list() {
    return Array.from(U.keys());
  },
  /** Reset — for use in tests only. */
  clear() {
    U.clear();
  }
}, H = /* @__PURE__ */ new Set();
let q = "app-wins";
function Je(e) {
  q = e;
}
function Xe() {
  return q;
}
function me(e) {
  const { name: t } = e;
  return !t || typeof e.template != "string" ? !1 : d.has(t) && !H.has(t) && q === "app-wins" ? (console.warn(
    `[GenUI] The server defines a component named "${t}", but "${t}" is already registered locally — keeping the local one (policy: "app-wins").
  • the widget will render with the SERVER's props, which the local component may not expect
  • to let the server win:  setServerComponentPolicy("server-wins")
  • or rename one of them so both can coexist.`
  ), !1) : (d.register(t, de(e)), H.add(t), !0);
}
function ve() {
  return pe.subscribe((e) => {
    for (const t of e) me(t);
  });
}
function Qe() {
  for (const e of H) d.unregister(e);
  H.clear(), q = "app-wins";
}
const ne = g`
  .chativa-bubble {
    background: #f1f5f9;
    color: #0f172a;
    border-radius: 4px 16px 16px 16px;
    padding: 9px 13px;
    font-family: var(--chativa-font-family, inherit);
    font-size: 0.875rem;
    line-height: 1.5;
    white-space: pre-wrap;
    word-break: break-word;
    width: fit-content;
    max-width: 100%;
    box-sizing: border-box;
  }
`;
var xe = Object.defineProperty, ye = Object.getOwnPropertyDescriptor, O = (e, t, s, i) => {
  for (var r = i > 1 ? void 0 : i ? ye(t, s) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (r = (i ? a(t, s, r) : a(r)) || r);
  return i && r && xe(t, s, r), r;
};
let v = class extends b {
  constructor() {
    super(...arguments), this.messageData = {}, this.sender = "bot", this.messageId = "", this.timestamp = 0, this.hideAvatar = !1, this.status = "sent", this.debug = !1, this._instances = /* @__PURE__ */ new Map(), this._listeners = /* @__PURE__ */ new Map(), this._dispatchedEvents = /* @__PURE__ */ new Set(), this._sendEvent = (e, t, s, i) => {
      const r = this._listeners.get(e);
      r && r.forEach(({ targetId: o, cb: a }) => {
        (o === void 0 || o === s) && a(t);
      }), this.dispatchEvent(
        new CustomEvent("genui-send-event", {
          detail: { msgId: this.messageId, eventType: e, payload: t, sourceId: s, ...i },
          bubbles: !0,
          composed: !0
        })
      );
    }, this._listenEvent = (e, t, s) => {
      this._listeners.has(e) || this._listeners.set(e, /* @__PURE__ */ new Set()), this._listeners.get(e).add({ targetId: s, cb: t });
    };
  }
  // ── Chunk rendering ───────────────────────────────────────────────────────
  _renderTextChunk(e) {
    return n`<div class="chunk-enter chativa-bubble">${e.content}</div>`;
  }
  _renderUIChunk(e) {
    const t = d.resolve(e.component);
    if (!t)
      return this.debug ? n`
        <div class="unknown-fallback chunk-enter">
          <strong>Unknown component:</strong> "${e.component}"
        </div>
      ` : n``;
    if (t.schema) {
      const i = t.schema.safeParse(e.props);
      if (!i.success)
        return console.error(`[GenUI] Prop validation failed for "${e.component}":`, i.error), n`
          <div class="error-fallback chunk-enter">
            <strong>Invalid props</strong> for "${e.component}" — see console for details.
          </div>
        `;
    }
    let s = this._instances.get(e.id);
    if (s && !(s instanceof t.component) && (this._instances.delete(e.id), s = void 0), !s) {
      s = new t.component(), this._instances.set(e.id, s);
      const i = s;
      i.sendEvent = (r, o, a) => this._sendEvent(r, o, e.id, { component: e.component, ...a }), i.listenEvent = (r, o) => this._listenEvent(r, o, e.id), i.tFn = (r, o) => ue(r, { defaultValue: o ?? r }), i.onLangChange = (r) => (M.on("languageChanged", r), () => M.off("languageChanged", r));
    }
    return Object.assign(s, e.props), n`<div class="chunk-enter">${s}</div>`;
  }
  // ── Dispatch pending event chunks ─────────────────────────────────────────
  _dispatchEventChunks(e) {
    for (const t of e) {
      if (this._dispatchedEvents.has(t.id)) continue;
      this._dispatchedEvents.add(t.id);
      const s = this._listeners.get(t.name);
      s && s.forEach(({ targetId: i, cb: r }) => {
        (t.for === void 0 || i === void 0 || i === t.for) && r(t.payload);
      });
    }
  }
  // ── Render ────────────────────────────────────────────────────────────────
  get _time() {
    return this.timestamp ? new Date(this.timestamp).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit"
    }) : "";
  }
  _renderAvatar(e) {
    return n`
      <div class="avatar ${this.hideAvatar ? "hidden" : ""}">
        ${e ? n`<img src=${e} alt="bot avatar" />` : n`
              <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <rect x="5" y="8" width="14" height="12" rx="2.5" />
                <circle cx="9.5" cy="13" r="1.5" fill="white" />
                <circle cx="14.5" cy="13" r="1.5" fill="white" />
                <path
                  d="M9.5 17c.5.5 1.4.8 2.5.8s2-.3 2.5-.8"
                  stroke="white"
                  stroke-width="1.2"
                  stroke-linecap="round"
                  fill="none"
                />
              </svg>
            `}
      </div>
    `;
  }
  render() {
    const e = this.messageData, t = e?.chunks ?? [], s = e?.streamingComplete ?? !1, i = t.filter((p) => p.type === "event");
    this._dispatchEventChunks(i);
    const r = t.filter(
      (p) => p.type !== "event"
    ), o = r[r.length - 1], a = !s && (!o || o.type !== "ui"), h = fe.getState().theme.avatar, u = h?.showBot !== !1;
    return n`
      <div class="message" role="article">
        ${u ? this._renderAvatar(h?.bot) : c}
        <div class="content">
          <div class="genui-wrapper">
            ${r.map((p) => p.type === "text" ? this._renderTextChunk(p) : p.type === "ui" ? this._renderUIChunk(p) : c)}
            ${a ? n`
              <div class="typing-dots">
                <span></span><span></span><span></span>
              </div>
            ` : c}
          </div>
          ${this._time ? n`<span class="time" aria-hidden="true">${this._time}</span>` : c}
        </div>
      </div>
    `;
  }
};
v.styles = [ne, g`
    :host {
      display: block;
      width: 100%;
    }

    /* Same row layout as the built-in message types so GenUI content
       lines up with regular bot bubbles (avatar gutter + 82% cap). */
    .message {
      display: flex;
      align-items: flex-end;
      gap: 8px;
      max-width: 82%;
      margin-right: auto;
      margin-bottom: 2px;
    }

    .avatar {
      width: 28px;
      height: 28px;
      border-radius: 50%;
      background: #ede9fe;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      overflow: hidden;
    }

    .avatar.hidden { visibility: hidden; }

    .avatar svg {
      width: 16px;
      height: 16px;
      color: #7c3aed;
    }

    .avatar img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 50%;
    }

    .content {
      display: flex;
      flex-direction: column;
      gap: 3px;
      flex: 1;
      min-width: 0;
      /* Single inheritance point for the whole GenUI subtree — built-in and
         custom components pick this up unless they override it themselves. */
      font-family: var(--chativa-font-family, inherit);
    }

    /* Text chunks render as regular bot bubbles (shared chativa-bubble
       look from ../styles/bubble) so mixed text + component streams read
       like one conversation. */

    .genui-wrapper {
      display: flex;
      flex-direction: column;
      gap: 10px;
      padding: 4px 0;
      min-width: 0;
    }

    .chunk-enter {
      animation: chunkFadeIn 0.35s ease-out both;
      max-width: 100%;
      min-width: 0;
    }

    /* Custom components can declare any width — never let them push
       past the message column (widget viewport). */
    .chunk-enter > * {
      max-width: 100%;
      box-sizing: border-box;
    }

    .time {
      font-size: 0.6875rem;
      color: #94a3b8;
      padding: 0 2px;
    }

    @keyframes chunkFadeIn {
      from { opacity: 0; transform: translateY(8px); }
      to   { opacity: 1; transform: translateY(0); }
    }

    .typing-dots {
      display: flex;
      gap: 4px;
      padding: 6px 2px;
      align-items: center;
    }

    .typing-dots span {
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background: #94a3b8;
      animation: dotBounce 1.2s infinite ease-in-out;
    }

    .typing-dots span:nth-child(2) { animation-delay: 0.15s; }
    .typing-dots span:nth-child(3) { animation-delay: 0.30s; }

    @keyframes dotBounce {
      0%, 80%, 100% { transform: translateY(0); opacity: 0.5; }
      40%            { transform: translateY(-5px); opacity: 1; }
    }

    .error-fallback {
      padding: 10px 14px;
      border: 1px dashed #f87171;
      border-radius: 8px;
      color: #ef4444;
      font-size: 0.8125rem;
      font-family: inherit;
    }

    .unknown-fallback {
      padding: 10px 14px;
      border: 1px dashed #fb923c;
      border-radius: 8px;
      color: #ea580c;
      font-size: 0.8125rem;
      font-family: inherit;
    }
  `];
O([
  l({ type: Object })
], v.prototype, "messageData", 2);
O([
  l({ type: String })
], v.prototype, "sender", 2);
O([
  l({ type: String })
], v.prototype, "messageId", 2);
O([
  l({ type: Number })
], v.prototype, "timestamp", 2);
O([
  l({ type: Boolean })
], v.prototype, "hideAvatar", 2);
O([
  l({ type: String })
], v.prototype, "status", 2);
O([
  l({ type: Boolean })
], v.prototype, "debug", 2);
v = O([
  m("genui-message")
], v);
try {
  he.register("genui", v);
} catch {
}
var _e = Object.defineProperty, we = Object.getOwnPropertyDescriptor, ae = (e, t, s, i) => {
  for (var r = i > 1 ? void 0 : i ? we(t, s) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (r = (i ? a(t, s, r) : a(r)) || r);
  return i && r && _e(t, s, r), r;
};
let V = class extends b {
  constructor() {
    super(...arguments), this.content = "";
  }
  render() {
    return n`<div class="chativa-bubble">${this.content}</div>`;
  }
};
V.styles = [
  ne,
  g`
      :host {
        display: block;
      }
    `
];
ae([
  l({ type: String })
], V.prototype, "content", 2);
V = ae([
  m("genui-text-block")
], V);
var $e = Object.defineProperty, ke = Object.getOwnPropertyDescriptor, R = (e, t, s, i) => {
  for (var r = i > 1 ? void 0 : i ? ke(t, s) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (r = (i ? a(t, s, r) : a(r)) || r);
  return i && r && $e(t, s, r), r;
};
let P = class extends b {
  constructor() {
    super(...arguments), this.title = "", this.description = "", this.image = "", this.actions = [];
  }
  _onAction(e) {
    this.dispatchEvent(
      new CustomEvent("chat-action", {
        detail: e,
        bubbles: !0,
        composed: !0
      })
    );
  }
  render() {
    return n`
      <div class="card">
        ${this.image ? n`<img class="card-image" src=${this.image} alt=${this.title} />` : c}
        <div class="card-body">
          ${this.title ? n`<h3 class="card-title">${this.title}</h3>` : c}
          ${this.description ? n`<p class="card-description">${this.description}</p>` : c}
          ${this.actions.length > 0 ? n`
                <div class="card-actions">
                  ${this.actions.map(
      (e) => n`
                      <button
                        class="action-btn"
                        type="button"
                        @click=${() => this._onAction(e.value)}
                      >${e.label}</button>
                    `
    )}
                </div>
              ` : c}
        </div>
      </div>
    `;
  }
};
P.styles = g`
    :host {
      display: block;
    }

    .card {
      border: 1px solid #e2e8f0;
      border-radius: 12px;
      overflow: hidden;
      background: #ffffff;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
      transition: box-shadow 0.2s ease;
      max-width: 320px;
      font-family: inherit;
    }

    .card:hover {
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
    }

    .card-image {
      width: 100%;
      height: 160px;
      object-fit: cover;
      display: block;
    }

    .card-body {
      padding: 14px 16px;
    }

    .card-title {
      margin: 0 0 6px;
      font-size: 1rem;
      font-weight: 600;
      color: #0f172a;
    }

    .card-description {
      margin: 0 0 12px;
      font-size: 0.8125rem;
      color: #64748b;
      line-height: 1.5;
    }

    .card-actions {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
    }

    .action-btn {
      padding: 7px 14px;
      border: 1.5px solid var(--chativa-primary-color, #4f46e5);
      border-radius: 999px;
      background: transparent;
      color: var(--chativa-primary-color, #4f46e5);
      font-size: 0.8125rem;
      font-weight: 500;
      cursor: pointer;
      font-family: inherit;
      transition: background 0.15s, color 0.15s;
    }

    .action-btn:hover {
      background: var(--chativa-primary-color, #4f46e5);
      color: #ffffff;
    }
  `;
R([
  l({ type: String })
], P.prototype, "title", 2);
R([
  l({ type: String })
], P.prototype, "description", 2);
R([
  l({ type: String })
], P.prototype, "image", 2);
R([
  l({ type: Array })
], P.prototype, "actions", 2);
P = R([
  m("genui-card")
], P);
var Pe = Object.defineProperty, Se = Object.getOwnPropertyDescriptor, I = (e, t, s, i) => {
  for (var r = i > 1 ? void 0 : i ? Se(t, s) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (r = (i ? a(t, s, r) : a(r)) || r);
  return i && r && Pe(t, s, r), r;
};
let x = class extends b {
  constructor() {
    super(...arguments), this.title = "", this.fields = [], this.buttonText = "", this._submitted = !1, this._processing = !1, this._successMessage = "", this._errorMessage = "";
  }
  connectedCallback() {
    super.connectedCallback(), this.listenEvent?.("form_success", (e) => {
      this._processing = !1, this._submitted = !0;
      const t = e;
      this._successMessage = t.message ?? this.t("genui.form.successDefault", { defaultValue: "Done!" });
    }), this.listenEvent?.("form_error", (e) => {
      this._processing = !1;
      const t = e;
      this._errorMessage = t.message ?? this.t("genui.form.errorDefault", { defaultValue: "Something went wrong." });
    });
  }
  _onSubmit(e) {
    if (e.preventDefault(), this._processing || this._submitted) return;
    const t = e.target, s = {};
    new FormData(t).forEach((i, r) => {
      s[r] = String(i);
    }), this._processing = !0, this._errorMessage = "", this.sendEvent?.("form_submit", s);
  }
  render() {
    const e = this.buttonText || this.t("genui.form.submit", { defaultValue: "Submit" });
    return this._submitted ? n`
        <div class="success-card">
          <div class="success-icon">✅</div>
          <h3 class="success-title">${this.t("genui.form.successTitle", { defaultValue: "Success" })}</h3>
          <p class="success-message">${this._successMessage}</p>
        </div>
      ` : n`
      <div class="form-card">
        ${this.title ? n`<h3 class="form-title">${this.title}</h3>` : c}
        <form @submit=${this._onSubmit}>
          ${this.fields.map((t) => n`
            <div class="field">
              <label for="genui-field-${t.name}">${t.label}</label>
              <input
                id="genui-field-${t.name}"
                name=${t.name}
                type=${t.type}
                placeholder=${t.placeholder ?? ""}
                .value=${t.value ?? ""}
                ?required=${t.required !== !1}
                ?disabled=${t.disabled === !0 || this._processing}
              />
            </div>
          `)}
          <button
            class="submit-btn"
            type="submit"
            ?disabled=${this._processing}
          >
            ${this._processing ? this.t("genui.form.processing", { defaultValue: "Processing…" }) : e}
          </button>
          ${this._errorMessage ? n`<div class="error-msg">${this._errorMessage}</div>` : c}
        </form>
      </div>
    `;
  }
};
x.styles = g`
    :host {
      display: block;
    }

    .form-card {
      border: 1px solid #e2e8f0;
      border-radius: 12px;
      padding: 20px;
      max-width: 360px;
      background: #ffffff;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
      font-family: inherit;
    }

    .form-title {
      margin: 0 0 16px;
      font-size: 1rem;
      font-weight: 600;
      color: #0f172a;
    }

    .field {
      margin-bottom: 14px;
    }

    label {
      display: block;
      font-size: 0.8125rem;
      font-weight: 500;
      color: #475569;
      margin-bottom: 4px;
    }

    input {
      width: 100%;
      padding: 8px 12px;
      border: 1.5px solid #e2e8f0;
      border-radius: 8px;
      font-size: 0.875rem;
      box-sizing: border-box;
      background: #f8fafc;
      color: #0f172a;
      font-family: inherit;
      transition: border-color 0.15s;
      outline: none;
    }

    input:focus {
      border-color: var(--chativa-primary-color, #4f46e5);
      background: #ffffff;
    }

    input:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }

    .submit-btn {
      width: 100%;
      padding: 10px;
      background: var(--chativa-primary-color, #4f46e5);
      color: #ffffff;
      border: none;
      border-radius: 8px;
      font-size: 0.875rem;
      font-weight: 500;
      cursor: pointer;
      font-family: inherit;
      transition: opacity 0.15s;
      margin-top: 4px;
    }

    .submit-btn:hover { opacity: 0.9; }
    .submit-btn:disabled { opacity: 0.5; cursor: not-allowed; }

    /* Success state */
    .success-card {
      border: 1px solid #bbf7d0;
      border-radius: 12px;
      padding: 20px;
      max-width: 360px;
      background: #f0fdf4;
      text-align: center;
      font-family: inherit;
    }

    .success-icon {
      font-size: 2rem;
      margin-bottom: 8px;
    }

    .success-title {
      margin: 0 0 6px;
      font-size: 1rem;
      font-weight: 600;
      color: #15803d;
    }

    .success-message {
      font-size: 0.8125rem;
      color: #166534;
    }

    .error-msg {
      margin-top: 10px;
      padding: 8px 12px;
      background: #fef2f2;
      border: 1px solid #fecaca;
      border-radius: 6px;
      font-size: 0.8125rem;
      color: #dc2626;
    }
  `;
I([
  l({ type: String })
], x.prototype, "title", 2);
I([
  l({ type: Array })
], x.prototype, "fields", 2);
I([
  l({ type: String })
], x.prototype, "buttonText", 2);
I([
  $()
], x.prototype, "_submitted", 2);
I([
  $()
], x.prototype, "_processing", 2);
I([
  $()
], x.prototype, "_successMessage", 2);
I([
  $()
], x.prototype, "_errorMessage", 2);
x = I([
  m("genui-form")
], x);
var Ce = Object.defineProperty, ze = Object.getOwnPropertyDescriptor, N = (e, t, s, i) => {
  for (var r = i > 1 ? void 0 : i ? ze(t, s) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (r = (i ? a(t, s, r) : a(r)) || r);
  return i && r && Ce(t, s, r), r;
};
let S = class extends b {
  constructor() {
    super(...arguments), this.variant = "info", this.title = "", this.message = "", this.icon = "";
  }
  _defaultIcon() {
    return {
      info: "ℹ️",
      success: "✅",
      warning: "⚠️",
      error: "❌"
    }[this.variant] ?? "ℹ️";
  }
  render() {
    const e = this.icon || this._defaultIcon();
    return n`
      <div class="alert alert--${this.variant}" role="alert">
        <span class="icon" aria-hidden="true">${e}</span>
        <div class="body">
          ${this.title ? n`<p class="title">${this.title}</p>` : c}
          ${this.message ? n`<p class="message">${this.message}</p>` : c}
        </div>
      </div>
    `;
  }
};
S.styles = g`
    :host { display: block; }

    .alert {
      display: flex;
      gap: 12px;
      align-items: flex-start;
      padding: 14px 16px;
      border-radius: 10px;
      border-left: 4px solid;
      font-family: inherit;
      max-width: 420px;
    }

    .icon {
      font-size: 1.125rem;
      line-height: 1;
      flex-shrink: 0;
      margin-top: 1px;
    }

    .body { flex: 1; min-width: 0; }

    .title {
      margin: 0 0 2px;
      font-size: 0.875rem;
      font-weight: 600;
    }

    .message {
      margin: 0;
      font-size: 0.8125rem;
      line-height: 1.5;
    }

    /* Variants */
    .alert--info    { background: #eff6ff; border-color: #3b82f6; color: #1e40af; }
    .alert--success { background: #f0fdf4; border-color: #22c55e; color: #15803d; }
    .alert--warning { background: #fffbeb; border-color: #f59e0b; color: #92400e; }
    .alert--error   { background: #fef2f2; border-color: #ef4444; color: #991b1b; }
  `;
N([
  l({ type: String })
], S.prototype, "variant", 2);
N([
  l({ type: String })
], S.prototype, "title", 2);
N([
  l({ type: String })
], S.prototype, "message", 2);
N([
  l({ type: String })
], S.prototype, "icon", 2);
S = N([
  m("genui-alert")
], S);
var Oe = Object.defineProperty, Ie = Object.getOwnPropertyDescriptor, W = (e, t, s, i) => {
  for (var r = i > 1 ? void 0 : i ? Ie(t, s) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (r = (i ? a(t, s, r) : a(r)) || r);
  return i && r && Oe(t, s, r), r;
};
let E = class extends b {
  constructor() {
    super(...arguments), this.label = "", this.items = [], this._selectedValue = "";
  }
  _onSelect(e) {
    this._selectedValue || (this._selectedValue = e.value, this.dispatchEvent(
      new CustomEvent("chat-action", {
        detail: e.value,
        bubbles: !0,
        composed: !0
      })
    ));
  }
  render() {
    const e = !!this._selectedValue;
    return n`
      ${this.label ? n`<p class="label">${this.label}</p>` : c}
      <div class="buttons" role="list">
        ${this.items.map((t) => n`
          <button
            class="reply-btn ${this._selectedValue === t.value ? "reply-btn--selected" : ""}"
            type="button"
            role="listitem"
            ?disabled=${e}
            @click=${() => this._onSelect(t)}
          >${t.label}</button>
        `)}
      </div>
    `;
  }
};
E.styles = g`
    :host { display: block; }

    .label {
      font-size: 0.8125rem;
      color: #64748b;
      margin: 0 0 8px;
      font-family: inherit;
    }

    .buttons {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
    }

    .reply-btn {
      padding: 7px 16px;
      border: 1.5px solid var(--chativa-primary-color, #4f46e5);
      border-radius: 999px;
      background: transparent;
      color: var(--chativa-primary-color, #4f46e5);
      font-size: 0.875rem;
      font-weight: 500;
      cursor: pointer;
      font-family: inherit;
      transition: background 0.15s, color 0.15s, opacity 0.15s;
      white-space: nowrap;
    }

    .reply-btn:hover:not(:disabled) {
      background: var(--chativa-primary-color, #4f46e5);
      color: #ffffff;
    }

    .reply-btn:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }

    .reply-btn--selected {
      background: var(--chativa-primary-color, #4f46e5);
      color: #ffffff;
      opacity: 1 !important;
    }
  `;
W([
  l({ type: String })
], E.prototype, "label", 2);
W([
  l({ type: Array })
], E.prototype, "items", 2);
W([
  $()
], E.prototype, "_selectedValue", 2);
E = W([
  m("genui-quick-replies")
], E);
var De = Object.defineProperty, Ee = Object.getOwnPropertyDescriptor, J = (e, t, s, i) => {
  for (var r = i > 1 ? void 0 : i ? Ee(t, s) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (r = (i ? a(t, s, r) : a(r)) || r);
  return i && r && De(t, s, r), r;
};
let j = class extends b {
  constructor() {
    super(...arguments), this.title = "", this.ordered = !1, this.items = [];
  }
  _renderItems() {
    return this.items.map((e, t) => n`
      <li>
        ${this.ordered ? n`<span class="item-number">${t + 1}.</span>` : e.icon ? n`<span class="item-icon" aria-hidden="true">${e.icon}</span>` : n`<span class="item-icon" aria-hidden="true">•</span>`}
        <div class="item-body">
          <div class="item-text">${e.text}</div>
          ${e.secondary ? n`<div class="item-secondary">${e.secondary}</div>` : c}
        </div>
      </li>
    `);
  }
  render() {
    return n`
      <div class="list-container">
        ${this.title ? n`<h3 class="list-title">${this.title}</h3>` : c}
        ${this.ordered ? n`<ol>${this._renderItems()}</ol>` : n`<ul>${this._renderItems()}</ul>`}
      </div>
    `;
  }
};
j.styles = g`
    :host { display: block; }

    .list-container {
      background: #ffffff;
      border: 1px solid #e2e8f0;
      border-radius: 12px;
      padding: 16px;
      max-width: 400px;
      font-family: inherit;
    }

    .list-title {
      margin: 0 0 12px;
      font-size: 0.9375rem;
      font-weight: 600;
      color: #0f172a;
    }

    ol, ul {
      margin: 0;
      padding: 0;
      list-style: none;
      display: flex;
      flex-direction: column;
      gap: 6px;
    }

    li {
      display: flex;
      align-items: flex-start;
      gap: 10px;
      padding: 8px 10px;
      background: #f8fafc;
      border-radius: 8px;
    }

    .item-icon {
      font-size: 1rem;
      line-height: 1.4;
      flex-shrink: 0;
      min-width: 20px;
      text-align: center;
    }

    .item-number {
      font-size: 0.8125rem;
      font-weight: 600;
      color: var(--chativa-primary-color, #4f46e5);
      flex-shrink: 0;
      min-width: 20px;
      line-height: 1.4;
    }

    .item-body { flex: 1; min-width: 0; }

    .item-text {
      font-size: 0.875rem;
      color: #0f172a;
      line-height: 1.4;
    }

    .item-secondary {
      font-size: 0.75rem;
      color: #94a3b8;
      margin-top: 2px;
    }
  `;
J([
  l({ type: String })
], j.prototype, "title", 2);
J([
  l({ type: Boolean })
], j.prototype, "ordered", 2);
J([
  l({ type: Array })
], j.prototype, "items", 2);
j = J([
  m("genui-list")
], j);
var je = Object.defineProperty, Ae = Object.getOwnPropertyDescriptor, X = (e, t, s, i) => {
  for (var r = i > 1 ? void 0 : i ? Ae(t, s) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (r = (i ? a(t, s, r) : a(r)) || r);
  return i && r && je(t, s, r), r;
};
let A = class extends b {
  constructor() {
    super(...arguments), this.title = "", this.columns = [], this.rows = [];
  }
  render() {
    const e = this.columns.length === 0 && this.rows.every((t) => t.length === 2);
    return n`
      <div class="table-container">
        ${this.title ? n`<h3 class="table-title">${this.title}</h3>` : c}
        <div class="scroll-wrapper">
        <table>
          ${this.columns.length > 0 ? n`
            <thead>
              <tr>
                ${this.columns.map((t) => n`<th scope="col">${t}</th>`)}
              </tr>
            </thead>
          ` : c}
          <tbody>
            ${this.rows.map((t) => n`
              <tr>
                ${t.map((s, i) => n`
                  <td class=${e && i === 0 ? "kv-key" : ""}>${s}</td>
                `)}
              </tr>
            `)}
          </tbody>
        </table>
        </div>
      </div>
    `;
  }
};
A.styles = g`
    :host { display: block; }

    .table-container {
      background: #ffffff;
      border: 1px solid #e2e8f0;
      border-radius: 12px;
      overflow: hidden;
      max-width: 480px;
      font-family: inherit;
    }

    .scroll-wrapper {
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
    }

    .table-title {
      padding: 14px 16px 0;
      margin: 0 0 10px;
      font-size: 0.9375rem;
      font-weight: 600;
      color: #0f172a;
    }

    table {
      width: max-content;
      min-width: 100%;
      border-collapse: collapse;
      font-size: 0.8125rem;
    }

    thead th {
      background: #f1f5f9;
      padding: 9px 14px;
      text-align: left;
      font-weight: 600;
      color: #475569;
      border-bottom: 1px solid #e2e8f0;
    }

    tbody tr:nth-child(even) td {
      background: #f8fafc;
    }

    tbody td {
      padding: 9px 14px;
      color: #0f172a;
      border-bottom: 1px solid #f1f5f9;
      vertical-align: top;
    }

    tbody tr:last-child td { border-bottom: none; }

    /* Key-value mode (2 columns, no header) */
    .kv-key {
      font-weight: 500;
      color: #64748b;
      width: 40%;
    }
  `;
X([
  l({ type: String })
], A.prototype, "title", 2);
X([
  l({ type: Array })
], A.prototype, "columns", 2);
X([
  l({ type: Array })
], A.prototype, "rows", 2);
A = X([
  m("genui-table")
], A);
var Ge = Object.defineProperty, Ue = Object.getOwnPropertyDescriptor, D = (e, t, s, i) => {
  for (var r = i > 1 ? void 0 : i ? Ue(t, s) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (r = (i ? a(t, s, r) : a(r)) || r);
  return i && r && Ge(t, s, r), r;
};
let y = class extends b {
  constructor() {
    super(...arguments), this.title = "", this.maxStars = 5, this.readonly = !1, this.value = 0, this._selected = 0, this._hovered = 0, this._submitted = !1;
  }
  connectedCallback() {
    super.connectedCallback(), this.value && (this._selected = this.value);
  }
  _onStarClick(e) {
    this.readonly || this._submitted || (this._selected = e);
  }
  _onSubmit() {
    !this._selected || this._submitted || (this._submitted = !0, this.sendEvent?.("rating_submit", { rating: this._selected }));
  }
  render() {
    const e = Array.from({ length: this.maxStars }, (i, r) => r + 1), t = this._hovered || this._selected, s = this.readonly || this._submitted;
    return n`
      <div class="rating-card">
        ${this.title ? n`<h3 class="rating-title">${this.title}</h3>` : c}
        <div class="stars" role="group" aria-label=${this.t("genui.rating.ariaLabel", { defaultValue: "Star rating" })}>
          ${e.map((i) => n`
            <button
              class="star ${i <= t ? "star--active" : ""} ${i === this._hovered && !s ? "star--hovered" : ""}"
              type="button"
              aria-label=${this.t("genui.rating.starLabel", { count: i, defaultValue: "{{count}} star" })}
              ?disabled=${s}
              @click=${() => this._onStarClick(i)}
              @mouseenter=${() => {
      s || (this._hovered = i);
    }}
              @mouseleave=${() => {
      this._hovered = 0;
    }}
            >⭐</button>
          `)}
        </div>
        ${this._submitted ? n`<p class="thank-you">${this.t("genui.rating.thankYou", { defaultValue: "Thank you for your feedback!" })}</p>` : s ? c : n`
                <button
                  class="submit-btn"
                  type="button"
                  ?disabled=${!this._selected}
                  @click=${this._onSubmit}
                >${this.t("genui.rating.submit", { defaultValue: "Submit" })}</button>
              `}
      </div>
    `;
  }
};
y.styles = g`
    :host { display: block; }

    .rating-card {
      background: #ffffff;
      border: 1px solid #e2e8f0;
      border-radius: 12px;
      padding: 18px 20px;
      max-width: 320px;
      text-align: center;
      font-family: inherit;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    }

    .rating-title {
      margin: 0 0 14px;
      font-size: 0.9375rem;
      font-weight: 600;
      color: #0f172a;
    }

    .stars {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      gap: 4px;
      /* Breathing room so the hover scale-up never clips or spills
         past the card edge. */
      padding: 4px 6px;
      margin-bottom: 10px;
    }

    .star {
      font-size: 1.75rem;
      cursor: pointer;
      transition: transform 0.1s ease, opacity 0.1s;
      line-height: 1.2;
      border: none;
      background: none;
      padding: 2px 3px;
      opacity: 0.3;
      user-select: none;
    }

    .star:focus-visible {
      outline: 2px solid var(--chativa-primary-color, #4f46e5);
      border-radius: 4px;
    }

    .star--active { opacity: 1; }
    .star--hovered { transform: scale(1.2); opacity: 1; }

    .star[disabled] { cursor: default; }

    .submit-btn {
      padding: 8px 24px;
      background: var(--chativa-primary-color, #4f46e5);
      color: #ffffff;
      border: none;
      border-radius: 8px;
      font-size: 0.875rem;
      font-weight: 500;
      cursor: pointer;
      font-family: inherit;
      transition: opacity 0.15s;
    }

    .submit-btn:hover { opacity: 0.88; }
    .submit-btn:disabled { opacity: 0.4; cursor: not-allowed; }

    .thank-you {
      font-size: 0.875rem;
      color: #16a34a;
      font-weight: 500;
    }
  `;
D([
  l({ type: String })
], y.prototype, "title", 2);
D([
  l({ type: Number })
], y.prototype, "maxStars", 2);
D([
  l({ type: Boolean })
], y.prototype, "readonly", 2);
D([
  l({ type: Number })
], y.prototype, "value", 2);
D([
  $()
], y.prototype, "_selected", 2);
D([
  $()
], y.prototype, "_hovered", 2);
D([
  $()
], y.prototype, "_submitted", 2);
y = D([
  m("genui-rating")
], y);
var Me = Object.defineProperty, Te = Object.getOwnPropertyDescriptor, Y = (e, t, s, i) => {
  for (var r = i > 1 ? void 0 : i ? Te(t, s) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (r = (i ? a(t, s, r) : a(r)) || r);
  return i && r && Me(t, s, r), r;
};
let C = class extends b {
  constructor() {
    super(...arguments), this.label = "", this.value = 0, this.caption = "", this.variant = "default";
  }
  render() {
    const e = Math.min(100, Math.max(0, this.value));
    return n`
      <div class="progress-container">
        ${this.label || e !== void 0 ? n`
          <div class="progress-header">
            ${this.label ? n`<span class="progress-label">${this.label}</span>` : c}
            <span class="progress-value">${e}%</span>
          </div>
        ` : c}
        <div class="track" role="progressbar" aria-valuenow=${e} aria-valuemin="0" aria-valuemax="100">
          <div class="bar bar--${this.variant}" style="width: ${e}%"></div>
        </div>
        ${this.caption ? n`<p class="progress-caption">${this.caption}</p>` : c}
      </div>
    `;
  }
};
C.styles = g`
    :host { display: block; }

    .progress-container {
      background: #ffffff;
      border: 1px solid #e2e8f0;
      border-radius: 10px;
      padding: 14px 16px;
      max-width: 400px;
      font-family: inherit;
    }

    .progress-header {
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      margin-bottom: 8px;
    }

    .progress-label {
      font-size: 0.875rem;
      font-weight: 500;
      color: #0f172a;
    }

    .progress-value {
      font-size: 0.8125rem;
      font-weight: 600;
      color: #64748b;
    }

    .track {
      width: 100%;
      height: 8px;
      background: #e2e8f0;
      border-radius: 999px;
      overflow: hidden;
    }

    .bar {
      height: 100%;
      border-radius: 999px;
      transition: width 0.4s ease;
    }

    .bar--default { background: var(--chativa-primary-color, #4f46e5); }
    .bar--success  { background: #22c55e; }
    .bar--warning  { background: #f59e0b; }
    .bar--error    { background: #ef4444; }

    .progress-caption {
      margin-top: 6px;
      font-size: 0.75rem;
      color: #94a3b8;
    }
  `;
Y([
  l({ type: String })
], C.prototype, "label", 2);
Y([
  l({ type: Number })
], C.prototype, "value", 2);
Y([
  l({ type: String })
], C.prototype, "caption", 2);
Y([
  l({ type: String })
], C.prototype, "variant", 2);
C = Y([
  m("genui-progress")
], C);
var Le = Object.defineProperty, Ve = Object.getOwnPropertyDescriptor, T = (e, t, s, i) => {
  for (var r = i > 1 ? void 0 : i ? Ve(t, s) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (r = (i ? a(t, s, r) : a(r)) || r);
  return i && r && Le(t, s, r), r;
};
let w = class extends b {
  constructor() {
    super(...arguments), this.disabled = !1;
  }
  _onChange(e) {
    const t = e.target.value;
    this.value = t, this.sendEvent?.("date_select", { date: t });
  }
  render() {
    const e = this.label ?? this.t("genui.datePicker.label");
    return n`
      <div class="date-card">
        <label for="genui-date-input">${e}</label>
        <input
          id="genui-date-input"
          type="date"
          .value=${this.value ?? ""}
          ?disabled=${this.disabled}
          min=${this.min ?? c}
          max=${this.max ?? c}
          @change=${this._onChange}
        />
      </div>
    `;
  }
};
w.styles = g`
    :host {
      display: block;
    }

    .date-card {
      border: 1px solid #e2e8f0;
      border-radius: 12px;
      padding: 16px 20px;
      max-width: 320px;
      background: #ffffff;
      font-family: inherit;
    }

    label {
      display: block;
      font-size: 0.8125rem;
      font-weight: 500;
      color: #475569;
      margin-bottom: 6px;
    }

    input[type="date"] {
      width: 100%;
      padding: 8px 12px;
      border: 1.5px solid #e2e8f0;
      border-radius: 8px;
      font-size: 0.875rem;
      box-sizing: border-box;
      background: #f8fafc;
      color: #0f172a;
      font-family: inherit;
      transition: border-color 0.15s;
      outline: none;
    }

    input[type="date"]:focus {
      border-color: var(--chativa-primary-color, #4f46e5);
      background: #ffffff;
    }

    input[type="date"]:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  `;
T([
  l({ type: String })
], w.prototype, "label", 2);
T([
  l({ type: String })
], w.prototype, "min", 2);
T([
  l({ type: String })
], w.prototype, "max", 2);
T([
  l({ type: String })
], w.prototype, "value", 2);
T([
  l({ type: Boolean })
], w.prototype, "disabled", 2);
w = T([
  m("genui-date-picker")
], w);
var Be = Object.defineProperty, Re = Object.getOwnPropertyDescriptor, K = (e, t, s, i) => {
  for (var r = i > 1 ? void 0 : i ? Re(t, s) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (r = (i ? a(t, s, r) : a(r)) || r);
  return i && r && Be(t, s, r), r;
};
const se = ["#4f46e5", "#7c3aed", "#06b6d4", "#10b981", "#f59e0b", "#ef4444"];
let z = class extends b {
  constructor() {
    super(...arguments), this.type = "bar", this.title = "";
  }
  _color(e, t) {
    return t ?? se[e % se.length];
  }
  // ── Bar chart ──────────────────────────────────────────────────────────────
  _renderBar() {
    const e = this.datasets ?? [], t = this.labels ?? [], s = e.flatMap((o) => o.data), i = Math.max(...s, 1), r = Math.max(...e.map((o) => o.data.length), t.length, 1);
    return n`
      <div class="bar-chart" role="img" aria-label=${this.title ?? "Bar chart"}>
        ${Array.from({ length: r }, (o, a) => n`
          <div class="bar-group">
            <div class="bars">
              ${e.map((h, u) => {
      const p = h.data[a] ?? 0, _ = Math.max(Math.round(p / i * 100), p > 0 ? 2 : 0);
      return n`
                  <div
                    class="bar"
                    style="height:${_}%;background:${this._color(u, h.color)};"
                    title="${h.label ? h.label + ": " : ""}${p}"
                  ></div>
                `;
    })}
            </div>
            ${t[a] ? n`<span class="bar-label">${t[a]}</span>` : c}
          </div>
        `)}
      </div>
      ${this._renderLegend()}
    `;
  }
  // ── Line chart ─────────────────────────────────────────────────────────────
  _renderLine() {
    const e = this.datasets ?? [];
    if (e.length === 0) return c;
    const t = 380, s = 150, i = 28, r = 16, o = e.flatMap((f) => f.data), a = Math.min(...o), h = Math.max(...o, a + 1), u = Math.max(...e.map((f) => f.data.length), 2), p = t - i * 2, _ = s - r * 2, k = (f) => i + f / (u - 1) * p, F = (f) => r + (h - f) / (h - a) * _;
    return n`
      <svg viewBox="0 0 ${t} ${s}" role="img" aria-label=${this.title ?? "Line chart"}>
        ${e.map((f, Z) => {
      const re = this._color(Z, f.color), ce = f.data.map((ee, te) => `${k(te)},${F(ee)}`).join(" ");
      return L`
            <polyline
              points="${ce}"
              fill="none"
              stroke="${re}"
              stroke-width="2"
              stroke-linejoin="round"
              stroke-linecap="round"
            />
            ${f.data.map((ee, te) => L`
              <circle cx="${k(te)}" cy="${F(ee)}" r="3.5" fill="${re}" />
            `)}
          `;
    })}
        ${(this.labels ?? []).map((f, Z) => L`
          <text
            x="${k(Z)}"
            y="${s - 2}"
            text-anchor="middle"
            font-size="9"
            fill="#94a3b8"
          >${f}</text>
        `)}
      </svg>
      ${this._renderLegend()}
    `;
  }
  // ── Pie chart ──────────────────────────────────────────────────────────────
  _renderPie() {
    const e = this.datasets ?? [];
    if (e.length === 0) return c;
    const t = e.map((u) => u.data[0] ?? 0), s = t.reduce((u, p) => u + p, 0) || 1, i = 50, r = 65, o = 65, a = 2 * Math.PI * i;
    let h = 0;
    return n`
      <svg viewBox="0 0 200 130" role="img" aria-label=${this.title ?? "Pie chart"}>
        ${e.map((u, p) => {
      const _ = t[p] / s, k = `${_ * a} ${a}`, F = h * 360 - 90;
      h += _;
      const f = this._color(p, u.color);
      return L`
            <circle
              cx="${r}"
              cy="${o}"
              r="${i}"
              fill="none"
              stroke="${f}"
              stroke-width="22"
              stroke-dasharray="${k}"
              transform="rotate(${F} ${r} ${o})"
            />
          `;
    })}
        ${e.map((u, p) => {
      const _ = this._color(p, u.color), k = 16 + p * 18;
      return L`
            <circle cx="142" cy="${k}" r="5" fill="${_}" />
            <text x="152" y="${k + 4}" font-size="10" fill="#475569">${u.label ?? ""}</text>
          `;
    })}
      </svg>
    `;
  }
  // ── Legend ─────────────────────────────────────────────────────────────────
  _renderLegend() {
    const e = this.datasets ?? [];
    return e.every((t) => !t.label) ? c : n`
      <div class="legend">
        ${e.map((t, s) => n`
          <span class="legend-item">
            <span class="legend-dot" style="background:${this._color(s, t.color)};"></span>
            ${t.label}
          </span>
        `)}
      </div>
    `;
  }
  // ── Render ─────────────────────────────────────────────────────────────────
  render() {
    return n`
      <div class="chart-container">
        ${this.title ? n`<h3 class="chart-title">${this.title}</h3>` : c}
        ${this.type === "line" ? this._renderLine() : this.type === "pie" ? this._renderPie() : this._renderBar()}
      </div>
    `;
  }
};
z.styles = g`
    :host {
      display: block;
    }

    .chart-container {
      background: #ffffff;
      border: 1px solid #e2e8f0;
      border-radius: 12px;
      padding: 16px;
      max-width: 420px;
      font-family: inherit;
    }

    .chart-title {
      margin: 0 0 14px;
      font-size: 0.9375rem;
      font-weight: 600;
      color: #0f172a;
    }

    /* Bar chart */
    .bar-chart {
      display: flex;
      align-items: flex-end;
      gap: 6px;
      height: 160px;
    }

    .bar-group {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;
      height: 100%;
      justify-content: flex-end;
      min-width: 0;
    }

    .bars {
      display: flex;
      align-items: flex-end;
      gap: 2px;
      width: 100%;
      height: calc(100% - 18px);
    }

    .bar {
      flex: 1;
      border-radius: 3px 3px 0 0;
      min-height: 2px;
      transition: opacity 0.15s;
    }

    .bar:hover {
      opacity: 0.8;
    }

    .bar-label {
      font-size: 0.625rem;
      color: #64748b;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;
      flex-shrink: 0;
    }

    /* Legend */
    .legend {
      display: flex;
      flex-wrap: wrap;
      gap: 6px 14px;
      margin-top: 12px;
    }

    .legend-item {
      display: flex;
      align-items: center;
      gap: 5px;
      font-size: 0.75rem;
      color: #475569;
    }

    .legend-dot {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      flex-shrink: 0;
    }

    /* SVG charts */
    svg {
      width: 100%;
      display: block;
      overflow: visible;
    }
  `;
K([
  l({ type: String })
], z.prototype, "type", 2);
K([
  l({ type: String })
], z.prototype, "title", 2);
K([
  l({ type: Array })
], z.prototype, "labels", 2);
K([
  l({ type: Array })
], z.prototype, "datasets", 2);
z = K([
  m("genui-chart")
], z);
var Ne = Object.defineProperty, Ye = Object.getOwnPropertyDescriptor, le = (e, t, s, i) => {
  for (var r = i > 1 ? void 0 : i ? Ye(t, s) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (r = (i ? a(t, s, r) : a(r)) || r);
  return i && r && Ne(t, s, r), r;
};
let B = class extends b {
  _renderIcon(e) {
    return e === "done" ? n`
        <div class="step-icon step-icon--done">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M2 6l3 3 5-5" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      ` : e === "active" ? n`
        <div class="step-icon step-icon--active">
          <div style="width:8px;height:8px;background:white;border-radius:50%;"></div>
        </div>
      ` : n`<div class="step-icon step-icon--pending"></div>`;
  }
  render() {
    const e = this.steps ?? [];
    return e.length === 0 ? c : n`
      <div class="steps-container">
        ${e.map((t) => n`
          <div class="step">
            <div class="step-left ${t.status}">
              ${this._renderIcon(t.status)}
            </div>
            <div class="step-content">
              <div class="step-label ${t.status === "pending" ? "step-label--pending" : ""}">
                ${t.label}
              </div>
              ${t.description ? n`<div class="step-description">${t.description}</div>` : c}
            </div>
          </div>
        `)}
      </div>
    `;
  }
};
B.styles = g`
    :host {
      display: block;
    }

    .steps-container {
      background: #ffffff;
      border: 1px solid #e2e8f0;
      border-radius: 12px;
      padding: 16px 20px;
      max-width: 380px;
      font-family: inherit;
    }

    .step {
      display: flex;
      gap: 12px;
      position: relative;
    }

    /* Vertical connector line between steps */
    .step:not(:last-child) .step-left::after {
      content: "";
      position: absolute;
      left: 11px;
      top: 28px;
      bottom: -6px;
      width: 2px;
      background: #e2e8f0;
    }

    .step:not(:last-child) .step-left.done::after {
      background: var(--chativa-primary-color, #4f46e5);
    }

    .step-left {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      flex-shrink: 0;
    }

    .step-icon {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      z-index: 1;
    }

    .step-icon--done {
      background: var(--chativa-primary-color, #4f46e5);
      color: #ffffff;
    }

    .step-icon--active {
      background: var(--chativa-primary-color, #4f46e5);
      animation: step-pulse 1.4s ease-in-out infinite;
    }

    .step-icon--pending {
      background: #ffffff;
      border: 2px solid #e2e8f0;
    }

    @keyframes step-pulse {
      0%, 100% { box-shadow: 0 0 0 0 rgba(79, 70, 229, 0.4); }
      50%       { box-shadow: 0 0 0 6px rgba(79, 70, 229, 0); }
    }

    .step-content {
      padding-bottom: 16px;
      flex: 1;
      min-width: 0;
    }

    .step:last-child .step-content {
      padding-bottom: 0;
    }

    .step-label {
      font-size: 0.875rem;
      font-weight: 600;
      color: #0f172a;
      line-height: 1.5;
    }

    .step-label--pending {
      color: #94a3b8;
      font-weight: 400;
    }

    .step-description {
      font-size: 0.8125rem;
      color: #64748b;
      margin-top: 2px;
      line-height: 1.4;
    }
  `;
le([
  l({ type: Array })
], B.prototype, "steps", 2);
B = le([
  m("genui-steps")
], B);
var Ke = Object.defineProperty, Fe = Object.getOwnPropertyDescriptor, Q = (e, t, s, i) => {
  for (var r = i > 1 ? void 0 : i ? Fe(t, s) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (r = (i ? a(t, s, r) : a(r)) || r);
  return i && r && Ke(t, s, r), r;
};
let G = class extends b {
  constructor() {
    super(...arguments), this._lightboxIndex = null;
  }
  _open(e) {
    this._lightboxIndex = e;
  }
  _close() {
    this._lightboxIndex = null;
  }
  _prev() {
    if (this._lightboxIndex === null) return;
    const e = this.images?.length ?? 0;
    this._lightboxIndex = (this._lightboxIndex - 1 + e) % e;
  }
  _next() {
    if (this._lightboxIndex === null) return;
    const e = this.images?.length ?? 0;
    this._lightboxIndex = (this._lightboxIndex + 1) % e;
  }
  _onKeydown(e) {
    this._lightboxIndex !== null && (e.key === "Escape" ? this._close() : e.key === "ArrowLeft" ? this._prev() : e.key === "ArrowRight" && this._next());
  }
  connectedCallback() {
    super.connectedCallback(), this._boundKeydown = this._onKeydown.bind(this), window.addEventListener("keydown", this._boundKeydown);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this._boundKeydown && window.removeEventListener("keydown", this._boundKeydown);
  }
  render() {
    const e = this.images ?? [], t = this.columns ?? 2;
    return n`
      <div class="gallery" style="grid-template-columns: repeat(${t}, 1fr);">
        ${e.map((s, i) => n`
          <div class="thumb-wrap">
            <div
              class="thumb"
              @click=${() => this._open(i)}
              role="button"
              tabindex="0"
              aria-label="${s.alt ?? s.caption ?? `Image ${i + 1}`}"
              @keydown=${(r) => {
      (r.key === "Enter" || r.key === " ") && this._open(i);
    }}
            >
              <img src="${s.src}" alt="${s.alt ?? ""}" loading="lazy" />
            </div>
            ${s.caption ? n`<span class="caption">${s.caption}</span>` : c}
          </div>
        `)}
      </div>

      ${this._lightboxIndex !== null ? this._renderLightbox(e) : c}
    `;
  }
  _renderLightbox(e) {
    const t = this._lightboxIndex, s = e[t];
    return s ? n`
      <div
        class="lightbox"
        role="dialog"
        aria-modal="true"
        aria-label="Image lightbox"
        @click=${(i) => {
      i.target === i.currentTarget && this._close();
    }}
      >
        <button class="lightbox-close" aria-label="Close lightbox" @click=${this._close}>×</button>
        ${e.length > 1 ? n`
          <button class="lightbox-nav prev" aria-label="Previous image" @click=${this._prev}>‹</button>
          <button class="lightbox-nav next" aria-label="Next image" @click=${this._next}>›</button>
        ` : c}
        <img class="lightbox-img" src="${s.src}" alt="${s.alt ?? ""}" />
        ${s.caption ? n`<div class="lightbox-caption">${s.caption}</div>` : c}
      </div>
    ` : c;
  }
};
G.styles = g`
    :host {
      display: block;
    }

    .gallery {
      display: grid;
      gap: 6px;
    }

    .thumb-wrap {
      display: flex;
      flex-direction: column;
      gap: 3px;
    }

    .thumb {
      position: relative;
      aspect-ratio: 1;
      overflow: hidden;
      border-radius: 8px;
      cursor: pointer;
      background: #e2e8f0;
    }

    .thumb img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
      transition: transform 0.2s;
    }

    .thumb:hover img {
      transform: scale(1.05);
    }

    .caption {
      font-size: 0.68rem;
      color: #64748b;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    /* Lightbox */
    .lightbox {
      position: fixed;
      inset: 0;
      background: rgba(0, 0, 0, 0.88);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 9999;
    }

    .lightbox-img {
      max-width: 90vw;
      max-height: 85vh;
      border-radius: 8px;
      object-fit: contain;
      user-select: none;
    }

    .lightbox-close {
      position: absolute;
      top: 16px;
      right: 16px;
      background: none;
      border: none;
      color: white;
      font-size: 2rem;
      line-height: 1;
      cursor: pointer;
      padding: 4px 8px;
      border-radius: 6px;
      transition: background 0.15s;
    }

    .lightbox-close:hover {
      background: rgba(255, 255, 255, 0.15);
    }

    .lightbox-nav {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      background: rgba(255, 255, 255, 0.15);
      border: none;
      color: white;
      font-size: 1.25rem;
      padding: 10px 14px;
      cursor: pointer;
      border-radius: 50%;
      transition: background 0.15s;
      line-height: 1;
    }

    .lightbox-nav:hover {
      background: rgba(255, 255, 255, 0.3);
    }

    .lightbox-nav.prev {
      left: 16px;
    }

    .lightbox-nav.next {
      right: 16px;
    }

    .lightbox-caption {
      position: absolute;
      bottom: 16px;
      left: 0;
      right: 0;
      text-align: center;
      color: rgba(255, 255, 255, 0.8);
      font-size: 0.875rem;
      pointer-events: none;
    }
  `;
Q([
  l({ type: Array })
], G.prototype, "images", 2);
Q([
  l({ type: Number })
], G.prototype, "columns", 2);
Q([
  $()
], G.prototype, "_lightboxIndex", 2);
G = Q([
  m("genui-image-gallery")
], G);
async function* Ze(e) {
  if (!e.body) throw new Error("[GenUI] Response body is empty");
  const t = e.body.getReader(), s = new TextDecoder();
  let i = "";
  try {
    for (; ; ) {
      const { done: o, value: a } = await t.read();
      if (o) break;
      i += s.decode(a, { stream: !0 });
      const h = i.split(`
`);
      i = h.pop() ?? "";
      for (const u of h) {
        const p = u.trim();
        if (p)
          try {
            yield JSON.parse(p);
          } catch (_) {
            console.error("[GenUI] Failed to parse chunk:", p, _);
          }
      }
    }
    const r = i.trim();
    if (r)
      try {
        yield JSON.parse(r);
      } catch (o) {
        console.error("[GenUI] Failed to parse final chunk:", r, o);
      }
  } finally {
    t.releaseLock();
  }
}
d.register("genui-text", V);
d.register("genui-card", P);
d.register("genui-form", x);
d.register("genui-alert", S);
d.register("genui-quick-replies", E);
d.register("genui-list", j);
d.register("genui-table", A);
d.register("genui-rating", y);
d.register("genui-progress", C);
d.register("genui-date-picker", w);
d.register("genui-chart", z);
d.register("genui-steps", B);
d.register("genui-image-gallery", G);
d.register("genui-html", oe);
d.register("html", oe);
ve();
export {
  rt as GENUI_COMPONENT_EVENT,
  S as GenUIAlert,
  P as GenUICard,
  z as GenUIChart,
  w as GenUIDatePicker,
  it as GenUIElement,
  x as GenUIForm,
  st as GenUIHtmlElement,
  G as GenUIImageGallery,
  j as GenUIList,
  v as GenUIMessage,
  C as GenUIProgress,
  E as GenUIQuickReplies,
  y as GenUIRating,
  d as GenUIRegistry,
  B as GenUISteps,
  A as GenUITable,
  V as GenUITextBlock,
  ne as bubbleStyles,
  Qe as clearServerComponents,
  ot as defineGenUIComponent,
  nt as genUIDefinitionStore,
  Xe as getServerComponentPolicy,
  me as registerServerComponent,
  at as renderTemplate,
  lt as sanitizeHtml,
  Je as setServerComponentPolicy,
  Ze as streamFromFetch,
  ve as subscribeServerComponents
};
//# sourceMappingURL=index.js.map
